export function TitanLogo({ size = 34 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      alt="Титан"
      width={size}
      height={size}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  )
}
